// types
export const FETCH_LOTTOS = 'FETCH_LOTTOS'

// actions
export const fetchLottos = lottos => ({ type: FETCH_LOTTOS, lottos })